import { get } from '../../../../GlobalModules/Utility/Http';

/**
 * Fetch order prerequisites checklist
 * @returns {Promise} Checklist data showing which modules are ready
 */
export const getOrderPrerequisitesChecklist = async () => {
  try {
    const storeId = localStorage.getItem('store_id');
    const response = await get(`${process.env.EXTENDED_URL}/common/checklist_for_order`, { store_id: storeId });
    
    if (response && response.data && response.data.success) {
      return {
        success: true,
        data: response.data.data
      };
    }
    
    return {
      success: false,
      message: response?.data?.message || 'Failed to fetch checklist',
      data: null
    };
  } catch (error) {
    console.error('Error fetching order prerequisites checklist:', error);
    return {
      success: false,
      message: 'Error fetching prerequisites checklist',
      data: null
    };
  }
};

export default {
  getOrderPrerequisitesChecklist
};
